// Global
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { Components } from '.generated/templates/Feature.Components.model';
import { classnames } from 'tailwindcss-classnames';
// Components
import Container from 'components/helpers/Container';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';

import Heading, { propsFromFields } from 'components/helpers/Heading';
import { MissingDataSource } from 'components/helpers/EditingHelpText';

export type LayoutLeftThirdProps = Sitecore.Override.ComponentBase &
  Components.Layout.Fields.ColumnLayout;

export type LayoutLeftThirdShellProps = {
  left: JSX.Element;
  right: JSX.Element;
  isSearchPage: boolean;
};

export const LayoutLeftThirdShell = ({
  left,
  right,
  isSearchPage,
}: LayoutLeftThirdShellProps): JSX.Element => {
  const rightPlaceholder = right.props.rendering?.placeholders['nmdp-two-thirds-width'];
  const rightPlaceholderIsEmpty = rightPlaceholder && rightPlaceholder.length === 0;
  return (
    <div
      className={classnames(
        isSearchPage ? 'lg:grid' : 'md:grid',
        'grid-cols-3',
        'md:gap-5',
        'lg:gap-7'
      )}
    >
      <div
        className={classnames(
          'leftthird-leftcol',
          'col-span-1',
          { 'mb-10': !rightPlaceholderIsEmpty, 'mb-0': rightPlaceholderIsEmpty },
          'md:mb-0'
        )}
      >
        {left}
      </div>
      <div className={classnames('col-span-2')}>{right}</div>
    </div>
  );
};

const LayoutLeftThird = ({ rendering, fields }: LayoutLeftThirdProps): JSX.Element => {
  if (fields === null || fields === undefined) {
    return <MissingDataSource />;
  }

  const headingProps = propsFromFields(fields);

  return (
    <Container size="standard" dataComponent="authorable/layout/layout-left-third">
      <div className={fields?.description.value ? classnames('mb-8') : ''}>
        <Heading {...headingProps} descriptionClassName={classnames('text-base')} />
      </div>
      <LayoutLeftThirdShell
        left={<PlaceholderWrapper name="nmdp-one-third-left" rendering={rendering} />}
        right={<PlaceholderWrapper name="nmdp-two-thirds-width" rendering={rendering} />}
        isSearchPage={false}
      />
    </Container>
  );
};

export default LayoutLeftThird;
